import Vue from 'vue'
import Router from 'vue-router'

import { Other } from './other';
Vue.use(Router)

const indexRouter=[
  {
    path: '/',
    name: 'index',
    meta: { title: 'menu1','isFoot':true},
    component: () => import('@/views/Index/home'),
  },
  // 目的地
  {
    path: '/destination',
    name: 'destination',
    meta: { title: 'destination','isFoot':true},
    component: () => import('@/views/destination/index'),
  },
  // 门票列表
  {
    path: '/ticket',
    name: 'ticket',
    meta: { title: 'ticket','isFoot':true},
    component: () => import('@/views/shopping/ticket'),
  },
  // 门票预订-目的地详情
  {
    path: '/ticketDetail',
    name: 'ticketDetail',
    meta: { title: 'ticketDetail','isFoot':true},
    component: () => import('@/views/shopping/ticketDetail'),
  },
  // 门票预订-门票详情
  {
    path: '/ticketInfoDetail',
    name: 'ticketInfoDetail',
    meta: { title: 'ticketInfoDetail','isFoot':true},
    component: () => import('@/views/shopping/ticketInfoDetail'),
  },
  // 门票预订-酒店详情
  {
    path: '/hotelDetail',
    name: 'hotelDetail',
    meta: { title: 'hotelDetail','isFoot':true},
    component: () => import('@/views/shopping/hotelDetail'),
  },
  // 餐饮预定-餐饮详情
  {
    path: '/restaurantDetail',
    name: 'restaurantDetail',
    meta: { title: 'restaurantDetail','isFoot':true},
    component: () => import('@/views/shopping/restaurantDetail'),
  },
  // 预订中心-旅游讲解
  {
    path: '/explanationDetail',
    name: 'explanationDetail',
    meta: { title: 'explanationDetail','isFoot':true},
    component: () => import('@/views/shopping/explanationDetail'),
  },
  // 游记攻略
  {
    path: '/travelNotes',
    name: 'travelNotes',
    meta: { title: 'travelNotes','isFoot':true},
    component: () => import('@/views/travelNotes/index'),
  },
  

  
]

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes:indexRouter.concat(Other)
})



// WEBPACK FOOTER //
// ./src/router/index.js